import { Fixture } from '@cds/betting-offer';
import { pprops } from '@frontend/sports/common/core/utils/redux';
import { createAction } from '@ngrx/store';

export interface ICompetitionGridAddEvents {
    id: string;
    fixtures: Fixture[] | undefined;
}

export class CompetitionGridActions {
    static ADD_EVENTS = '@competitions/ADD_EVENTS';

    static addEvents = createAction(CompetitionGridActions.ADD_EVENTS, pprops<ICompetitionGridAddEvents>());
}
